import { useEffect } from 'react';

/**
 * Keeps the screen on while mounted (wall display). Browsers release the lock when the tab is
 * hidden, so it is re-acquired on visibility change. Silently does nothing where unsupported.
 */
export function useWakeLock(enabled = true) {
  useEffect(() => {
    if (!enabled || !('wakeLock' in navigator)) return;
    let lock: WakeLockSentinel | undefined;
    let cancelled = false;

    const acquire = async () => {
      try {
        lock = await navigator.wakeLock.request('screen');
        if (cancelled) void lock.release();
      } catch {
        // Denied (battery saver, not visible) – the next visibility change retries.
      }
    };
    const onVisible = () => document.visibilityState === 'visible' && void acquire();

    void acquire();
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      cancelled = true;
      document.removeEventListener('visibilitychange', onVisible);
      void lock?.release();
    };
  }, [enabled]);
}
